/** Wire values of airportliner_be auth/models/permissions.js that the dispo tool uses. */
export const PERMISSIONS = {
    DISPO: 'dispo',
    VEHICLE_EDIT: 'vehicle_edit',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
